const styles = theme => ({
  title_container: {
    marginBottom: '1rem',
  },
  title: {
    fontWeight: 600,
    marginBottom: '5px',
  },
  adgmGreen: {
    color: theme.palette.primary.adgmGreen,
  },
  cardContent: {},
  paperCardFrame: {
    borderRadius: '0px',
    '& $cardContent': {
      minHeight: '70vh',
    },
  },
  contactsContainer: {
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.borderColor}`,
  },
  addNewContactBtnContainer: {
    [theme.breakpoints.up('sm')]: {
      paddingLeft: '24px',
      paddingRight: '24px',
    },
  },
  headerWraperComponent: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
      padding: '16px 0px',
    },
  },
  noTitleHeadXPaddingOnSm: {
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0px !important',
    },
  },
  titleHead: {
    background: 'transparent',
    color: '#342D3D',
    padding: '10px 16px',
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      // borderBottom: "1px solid #CED1D6",
      '& h1': {
        fontSize: '18px',
      },
    },
    '& h1': {
      fontSize: '16px',
      fontWeight: '600',
      margin: '0',
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0px',
    },
  },
  innerCard: {
    padding: '12px 16px',
  },
  saveBtnContainer: {
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
    '& button': {
      minWidth: '150px',
      '&:disabled': {
        background: '#CED1D6',
      },
    },
  },
  '@media (min-width: 960px)': {
    contentArea: {
      paddingLeft: '50px',
    },
  },
  // style No Primary Contact Comp
  NoPrimaryContactContainer: {
    maxWidth: '460px',
  },
  phoneIcon: {
    width: '125px',
    height: '125px',
    borderRadius: '50%',
    backgroundColor: '#EBEEF3',
  },
  textInfo: {
    color: theme.palette.primary.adgmInfo,
    '& strong': {
      cursor: 'pointer',
    },
  },
  inputGridContainer: {
    width: '100%',
    padding: '16px',
    [theme.breakpoints.down('sm')]: {
      width: '90%',
    },
  },
  inputGridContainer2: {
    width: '100%',
    padding: '16px',
  },
  // start style single contact
  contactContainer: {
    borderBottom: '1px solid #EBEEF3',
    padding: '12px 24px',
    width: '100%',
    '& > div': {
      cursor: 'pointer',
    },
  },
  details: {},
  avatarContainer: {
    maxWidth: '350px',
  },
  avatar: {
    width: '64px',
    height: '64px',
    [theme.breakpoints.down('sm')]: {
      width: '40px',
      height: '40px',
    },
    borderRadius: '50%',
    marginInlineEnd: '.75rem',
  },

  contactText: {
    fontSize: '16px',
    lineHeight: '24px',
    color: theme.palette.primary.adgmBlack,
  },
  textAr: {
    fontFamily: '"madani", sans-serif',
    lineHeight: '24px',
  },
  contatcLabel: {
    color: '#484456',
  },
  itemCheckbox: {
    padding: '0',
    marginInlineStart: '.5rem',
    marginRight: '5px',
    '& svg': {
      height: '20px',
      width: '20px',
    },
    color: '#0D2A3A !important',
  },
  itemCheckboxChecked: {
    color: `${theme.palette.primary.main} !important`,
  },
  checkDisabled: {
    cursor: 'not-allowed !important',
    pointerEvents: 'none !important',
  },
  removeContact: {
    width: 'max-content',
    '& p': {
      fontWeight: '600',
      lineHeight: '18px',
      fontSize: '20px',
      color: theme.palette.primary.errorRed,
      marginInlineStart: '.5rem',
    },
  },
  addNewContactBtn: {
    textTransform: 'none !important',
    '& p': {
      textTransform: 'none !important',
      marginInlineStart: '0.5rem',
      fontWeight: '600',
    },
  },
  addNewContactBtnLeft: {
    // marginRight: "auto",
  },
  subTitle1: {
    color: theme.palette.primary.errorRed + '!important',
    fontSize: '20px',
    fontWeight: 100,
  },
  // style remove Modal
  removeModal: {
    color: theme.palette.primary.adgmBlack,
    padding: '1rem',
    outline: 'none',
    '& h5': {
      fontWeight: '600',
      fontSize: '20px',
      marginBottom: '.5rem',
    },
    '& p': {
      fontWeight: '500',
      lineHeight: '26px',
    },
  },
  removeContainer: {
    padding: '2rem',
  },
  removeActions: {
    marginTop: '2rem',
    '& button': {
      height: '48px',
    },
    '& button:last-child': {
      backgroundColor: theme.palette.primary.errorRed,
      fontSize: '20px',
      color: '#fff',
      width: '59%',
    },
    '& button:first-child': {
      width: '39%',
    },
  },
  paperTypeBlock: {
    boxShadow: 'none !important',
  },
  // style successMsg
  successMsg: {
    border: '1px solid #12B78E',
    borderRadius: '10px',
    background: '#EDFDF9',
    height: '44px',
    '& img': {
      marginInlineEnd: '.4rem',
    },
    '& p': {
      fontSize: '12px',
      color: theme.palette.primary.adgmBlack,
    },
  },
  showMore: {
    // color: theme.palette.primary.adgmGreen,
    color: '#0088FF',
    lineHeight: '24px',
    borderBottom: '1px solid #EBEEF3',
    cursor: 'pointer',
    width: 'max-content',
    '& $arrowIcon': {
      marginInlineStart: '.5rem',
    },
  },
  label: {
    fontWeight: '400',
    lineHeight: '21px',
    fontSize: '14px',
    color: ' #484456',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  arrowIcon: {},
  checkboxContainer: {
    borderBottom: '1px solid #EBEEF3',
    '& label': {
      // flexDirection: 'row-reverse',
      width: '100%',
      // justifyContent: 'space-between',
      margin: '0rem',
      padding: '16px 24px',
      [theme.breakpoints.down('sm')]: {
        padding: '16px',
      },
      '& span:first-child': {
        // width: "20px !important",
      },
      '& span:last-child': {
        fontWeight: '600',
        fontSize: '18px',
        lineHeight: '24px',
        color: theme.palette.primary.adgmBlack,
        // width: '80%',
      },
      '& svg': {
        width: '20px !important',
        height: '20px !important',
      },
    },
    '& .Mui-checked': {
      '& span:first-child': {
        color: theme.palette.primary.lightADGMGreen + ' !important',
      },
    },
  },
  checkbox: {
    color: ' #130F26 ',
  },
  checked: {
    color: theme.palette.primary.lightADGMGreen + ' !important',
  },
  // Mui-checked
  // style info Msg
  infoMsg: {
    border: '1px solid #0496FF',
    background: theme.palette.primary.infoBlueLight,
    borderRadius: '10px',
    minHeight: '60px',
    '& $infoIcon': {
      marginInlineEnd: '.4rem',
    },
    '& p': {
      fontSize: '12px',
      color: theme.palette.primary.adgmBlack,
    },
    '& strong': {
      cursor: 'pointer',
    },
  },
  infoIcon: {},
  // style userAvatar
  userAvatar: {
    width: '92px',
    height: '92px',
  },

  [theme.breakpoints.down('sm')]: {
    title_container: {
      background: '#F8F8F8',
      color: '#342D3D',
      padding: '10px 16px',
      '& h1': {
        fontSize: '16px',
        fontWeight: '600',
        margin: '0',
      },
    },
    paperCardFrame: {
      marginBottom: '0px',
      borderRadius: '0px',
      border: '0px',
    },
    // style No Primary Contact Comp
    NoPrimaryContactContainer: {
      maxWidth: '350px',
    },
    phoneIcon: {
      width: '92px',
      height: '92px',
      '& img': {
        width: '32px',
      },
    },
    NoPrimaryContactTitle: {
      fontSize: '14ppx',
    },
    textInfo: {
      fontSize: '12ppx',
    },
    // style remove Modal
    removeModal: {
      padding: '.75rem',
      '& h5': {
        fontSize: '16px',
        marginBottom: '.57rem',
      },
      '& p': {
        lineHeight: '18px',
        fontSize: '12px',
      },
    },
    removeContainer: {
      padding: '0',
    },
    // start style single contact
    contactText: {
      fontSize: '12px',
      lineHeight: '18px',
      fontWeight: '500 !important',
    },
    textAr: {
      fontWeight: '600 !important',
    },
    contatcLabel: {
      fontSize: '12px',
    },
    addNewContactBtnContainer: {
      '& img': {
        width: '10px',
      },
      margin: '0px auto',
    },
    addNewContactBtn: {
      '& p': {
        fontSize: '12px',
      },
    },
    // style successMsg
    successMsg: {
      width: '95%',
    },
    showMore: {
      fontSize: '14px',
    },
    itemCheckbox: {
      position: 'absolute',
      right: '1rem',
      paddingTop: '18px',
      '& svg': {
        height: '24px',
        width: '24px',
      },
    },
    // style checkboxContainer
    checkboxContainer: {
      '& label': {
        '& span:first-child': {
          width: '24px !important',
        },
        '& span:last-child': {
          fontSize: '14px',
          lineHeight: '21px',
        },
        '& svg': {
          width: '24px !important',
          height: '24px !important',
        },
      },
    },
    contactContainer: {
      padding: '0px 0',
      // borderWidth: "8px",
      '& $avatarContainer': {
        padding: '0 16px',
      },
      '& $removeContact': {
        padding: '0 16px',
      },
    },
    contactDetails: {
      flexDirection: 'column',
      alignItems: 'start',
      position: 'relative',
      '& $details': {
        padding: '1rem',
        // borderBottom: "1px solid #EBEEF3",
        width: '100%',
      },
    },
  },
  '@media (max-width: 645px)': {
    inputGridContainer: {
      width: '92%',
      '& > div': {
        width: '100%',
      },
    },
    inputGridContainer2: {
      width: '100%',
      '& > div': {
        width: '100%',
      },
    },
    fetchTextField: {
      gridTemplateColumns: '9fr 3fr',
      columnGap: '6px',
    },

    // Buyer details styles
    buyerSummaryContainer: {
      '& $buyerInfoText': {
        fontWeight: 600,
        fontSize: '14px',
      },
    },
    panelTitle: {
      '& h6': {
        fontSize: '16px',
      },
    },
    accordianTitle: {
      '& p': {
        fontSize: '14px !important',
      },
    },
  },
  '@media (max-width: 768px)': {
    largeButton: {
      height: '48px',
      minWidth: '358px',
      borderRadius: '4px',
      border: '1px solid #130F26',
      '& img': {
        width: '16px',
        height: '16px',
      },
      '& p': {
        fontSize: '16px',
      },
    },
  },
  '@media (min-width: 768px)': {
    inputGridContainer: {
      padding: '16px 24px',
    },
    titleHead: {
      padding: '16px 0px',
      '& h1': {
        fontSize: '18px',
      },
    },
    headsubtitle: {
      fontSize: '16px',
      fontWeight: '400',
    },
    largeButton: {
      height: '48px',
      // minWidth: "293px",
      borderRadius: '0px',
      border: '1px solid #0D2A3A',
      '& svg path': {
        fill: theme.palette.primary.adgmBlack,
      },
      '&:hover': {
        '& svg path': {
          stroke: theme.palette.primary.white,
        },
        backgroundColor: theme.palette.primary.adgmHover,
        color: theme.palette.primary.white,
        border: 'none',
      },
      '& img': {
        width: '17px',
        height: '17px',
      },
      '& p': {
        fontSize: '16px',
      },
    },
    formControl: {
      gap: '16px',
    },

    addNewContactBtnContainer: {
      justifyContent: 'flex-end',
    },
    contactDetails: {
      '& $avatarContainer': {
        width: '45%',
      },
      '& $details': {
        width: '27%',
        marginInlineStart: '1rem',
      },
    },
  },
});

export default styles;
